<template>
  <div>
    <TableLayout title="متا">
      <template #buttons>

        <div>
          <router-link class="text-left ml-2 mt-1" :to="{ name: 'TrashMeta' }">
            <b-button pill variant="danger ">
              سطل زباله
            </b-button
            >
          </router-link>
        </div>
        <div>
          <router-link class="text-left ml-2 mt-1" :to="{ name: 'CreateMeta' }">
            <b-button pill variant="info">
              <b-icon icon="plus" class="mr-2" font-scale="1.5"/>
              ایجاد
            </b-button
            >
          </router-link>
        </div>


      </template>
      <template #table>

        <b-row>
          <b-col lg="6">
            <label class="mt-4"> نوع </label>
            <select v-model="form.meta_type" class="custom-select" @change="sortName()">
              <option value="">
                نمایش همه
              </option>
              <option v-for="type in meta_type_options" :value="type.value">
                {{ type.text }}
              </option>
            </select>
          </b-col>

          <b-col lg="6">
            <label class="mt-4">نام </label>
            <b-form-select
                v-model="form.meta_name"
                :options="meta_name_options"

            ></b-form-select>
          </b-col>
        </b-row>

        <b-table
            v-bind="tableAttributes"
            :fields="fields"
            :items="AddFilter()"
            class="mt-2"
            id="myTable">

          <template #cell(name)="data">
            {{ data.item.name }}
          </template>
          <template #cell(meta_key)="data">
            {{ data.item.meta_key }}
          </template>
          <template #cell(metaable_type)="data">
            {{ meta_types[data.item.metaable_type]  }}

          </template>
          <template #cell(function)="data">
            {{ data.item.function }}

            <b-icon class="ml-4" icon="trash" font-scale="1.5" @click="deleteMeta(data.item)"></b-icon>

            <router-link :to="{ name: 'UpdateMeta', params: { meta: data.item.id } }">
              <b-icon icon=" pencil" font-scale="1.5"/>
            </router-link>
          </template>
        </b-table>
      </template>
    </TableLayout>

  </div>
</template>

<script>
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {mapGetters} from "vuex";
import TableLayout from "../../components/dashboard/TableLayout";
import {meta_types} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Meta'

export default {
  name: "tableItems",
  components: {TableLayout},
  props: ["restoreState"],
  data() {
    return {
      meta_type_options: [],
      meta_name_options: [
        {value: null, text: "لطفا یک نوع را انتخاب کنید"},
      ],
      tableAttributes: {...tableAttributes, ...{responsive: "xl"}},
      fields: [
        {key: "name", label: "نام"},
        {key: "meta_key", label: "وضعیت"},
        {key: "metaable_type", label: "نوع"},
        {key: "function", label: "عملیات"},
      ],
      form: {
        meta_type: "",
        meta_name: "",
      },
      meta_types,
    };
  },
  computed: {
    ...mapGetters({
      metas: 'Meta/metas'
    })
  },
  mounted() {
    this.$store.dispatch('Meta/setMetas')
  },
  methods: {
    deleteMeta(item) {
      if (confirm('آیا از حذف این محصول اطمینان دارید؟')) {
        this.$store.dispatch("Meta/deleteMeta", item);
      }
    },

    sortType(metas) {
      let storeAddedItems = []
      metas.forEach(item => {
        if (storeAddedItems.indexOf(item.metaable_type) === -1) {
          this.meta_type_options.push({text: meta_types[item.metaable_type], value: item.metaable_type})
          storeAddedItems.push(item.metaable_type)
        }
      })
    },

    sortName() {

      this.meta_name_options = []

      if (this.form.meta_type) {
        this.metas.forEach(item => {
          if (item.metaable_type == this.form.meta_type) {
            if (this.meta_name_options.indexOf(item.name) === -1) {
              this.meta_name_options.push(item.name)
            }
          }
        })
      }
    },

    AddFilter() {

      if (!this.form.meta_type && !this.form.meta_name) {
        return this.metas;
      }

      if (this.form.meta_type && this.form.meta_name) {
        let obj = []
        this.metas.forEach(item => {
          if (item.metaable_type == this.form.meta_type && item.name == this.form.meta_name) {
            obj.push(item);
          }
        })
        this.bubbleSort(obj);
        return obj;
      }

      if (this.form.meta_type && !this.form.meta_name) {
        let obj = []
        this.metas.forEach(item => {
          if (item.metaable_type == this.form.meta_type) {
            obj.push(item);
          }
        })
        this.bubbleSort(obj);
        return obj;
      }
    },

    swap(arr, xp, yp) {
      var temp = arr[xp];
      arr[xp] = arr[yp];
      arr[yp] = temp;
    },

    bubbleSort(arr) {
      var i, j;
      for (i = 0; i < arr.length - 1; i++) {
        for (j = 0; j < arr.length - i - 1; j++) {
          if (parseInt(arr[j].value) > parseInt(arr[j + 1].value)) {
            this.swap(arr, j, j + 1);
          }
        }
      }
    },
  },
  watch: {
    metas: {
      handler: function (newValue, oldValue) {

        this.sortType(this.metas)

      },
      deep: true
    },
  }

};
</script>